import * as Sentry from '@sentry/nextjs';
import { useEffect } from 'react';
import ReactOneSignal from 'react-onesignal';

import { ONE_SIGNAL_ID } from '@/helpers/conf';
import { CLIENT_ENVS } from '@/helpers/constants';
import { useCommonStore } from '@/store';

const oneSignalBuilder =
  (appId?: string) => async (userId: number, email: string) => {
    try {
      if (appId == null || appId === '') {
        console.warn('OneSignal appId is not defined');
        Sentry.addBreadcrumb({
          message: 'OneSignal appId is not defined',
          category: 'oneSignal',
          level: 'warning',
        });
        return;
      }

      await ReactOneSignal.init({
        appId,
        allowLocalhostAsSecureOrigin: true,
      });

      ReactOneSignal.setExternalUserId(userId.toString());
      ReactOneSignal.setEmail(email);
    } catch {
      Sentry.addBreadcrumb({
        message: 'OneSignal init failed',
        category: 'oneSignal',
        level: 'error',
      });

      console.error('OneSignal init failed');
    }
  };

const oneSignal = oneSignalBuilder(ONE_SIGNAL_ID);

export const useOneSignal = () => {
  const user = useCommonStore.use.user();

  useEffect(() => {
    if (CLIENT_ENVS.APP_ENV === 'development') return;

    if (!user?.id || !user.email) return;

    oneSignal(user.id, user.email);
  }, [user]);
};
